module.exports = __webpack_public_path__ + "static/development-a92e27b6d2a0214c59c08870adeddb7a.png";